import { Link, useLocation } from 'react-router-dom';
import { useSiteLang, pageLang } from '@/components/site/SiteLang';

const T = {
  es: {
    code: 'Error 404',
    title: 'Esta página no existe',
    desc: 'Puede que el enlace esté mal escrito o que la página se haya movido.',
    home: 'Ir al inicio',
    members: 'Área de miembros',
  },
  en: {
    code: 'Error 404',
    title: 'This page doesn’t exist',
    desc: 'The link may be mistyped, or the page may have moved.',
    home: 'Back to the home page',
    members: 'Members’ area',
  },
};

export default function NotFound() {
  // Mismo idioma que la cabecera y el pie: inglés solo en rutas traducidas (las rutas inexistentes no lo son)
  const { lang } = useSiteLang();
  const { pathname } = useLocation();
  const t = T[pageLang(pathname, lang)] || T.es;
  return (
    <div className="min-h-screen bg-[#060D1B] flex items-center justify-center px-6 pt-28 pb-16">
      <div className="max-w-md text-center space-y-5">
        <p className="text-[#D4AF37] text-sm uppercase tracking-widest">{t.code}</p>
        <h1 className="text-white text-2xl font-semibold">{t.title}</h1>
        <p className="text-white/60 text-sm">{t.desc}</p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/" className="inline-flex items-center justify-center bg-[#D4AF37] text-[#0F172A] font-semibold px-5 h-11">{t.home}</Link>
          <Link to="/dashboard" className="inline-flex items-center justify-center border border-white/25 text-white px-5 h-11">{t.members}</Link>
        </div>
      </div>
    </div>
  );
}
